export enum EdsSelectPropertyNames {
  CoverageTypeId = 'CoverageTypeId',
  CoverageSourceId = 'CoverageSourceId',
  DocumentTypeId = 'DocumentTypeId',
  BeneficiaryStatusId = 'BeneficiaryStatusId',
  InsuranceProductId = 'InsuranceProductId',
  IsReporter = 'IsReporter',
  AssignmentTypeId = 'AssignmentTypeId',
  IsAssignee = 'IsAssignee',
  DocumentRecipient = 'DocumentRecipient',
  ClaimantPortalAccess = 'ClaimantPortalAccess',
  Prefix = 'Prefix',
  MaritalStatusId = 'MaritalStatusId',
  OccupationId = 'OccupationId',
  ValidCompanyId = 'ValidCompanyId',
  StatusId = 'StatusId',
  Contingent = 'Contingent',
  NoteTypeId = 'NoteTypeId',
  AssignmentQueueTypeId = 'AssignmentQueueTypeId',
  AssignmentQueueStrategyId = 'AssignmentQueueStrategyId',
  BeneficiaryVerificationStateId = 'BeneficiaryVerificationStateId',
  NotificationStatusId = 'NotificationStatusId',
  TaskStatusId = 'TaskStatusId',
  ContactPreferenceId = 'ContactPreferenceId',
  PaymentStatusId = 'PaymentStatusId',
  PaymentMethodType = 'PaymentMethodType',
  AccountTypeId = 'AccountTypeId',
  MilestoneId = 'MilestoneId',
  OverrideReasonId = 'OverrideReasonId',
  SitusStateId = 'SitusStateId',
  ProducerTypeId = 'ProducerTypeId',
  PolicySourceId = 'PolicySourceId',
  LineOfBusinessId = 'LineOfBusinessId',
  PolicyProductTypeId = 'PolicyProductTypeId',
  PolicyTypeId = 'PolicyTypeId',
  RelationshipId = 'RelationshipId',
  RelationshipTypeId = 'RelationshipTypeId',
}
